import React from 'react';
import { IFunctionalComponent } from '../interfaces/IFunctionalComponent';
import Analyzer from '../../cmp/page/Analyzer';
import DocumentUpload from '../../cmp/page/DocumentUpload';

const CmsFunctionalComponent : React.FC<IFunctionalComponent> = ({component}) => {
    return <>
        {component === "analyzer" && <Analyzer />}
        {component === "upload" && <DocumentUpload />}
    </>
}

export default CmsFunctionalComponent;